// src/pages/Users.jsx
// Users tab (3.9, was inside the Control Panel): the people in your
// account, the Activity log and Reminders. Sections, each with its own
// address (older /portal/control-panel/users|activity|reminders links open
// the same section):
//   /portal/users/people     User Management   (Roles & Access: users.view)
//   /portal/users/activity   Activity log      (activity.view)
//   /portal/users/sessions   User sessions     (sessions.view, 3.9.1)
//   (Reminders moved to Settings in 3.49.18; /portal/users/reminders opens it there)
//   /portal/users/teams      Teams             (teams.manage, 3.19.0)
// Super Admins see every section.
import { useAuth } from '../hooks/useAuth';
import SectionTabs from '../components/SectionTabs';
import UserManagement from './UserManagement';
import ActivityLog from './ActivityLog';
import Sessions from './Sessions';
import Teams from './Teams';

const SECTIONS = [
  { id: 'people',    label: 'People',       icon: '👥', perm: 'users.view' },
  { id: 'activity',  label: 'Activity log', icon: '📜', perm: 'activity.view' },
  { id: 'sessions',  label: 'Sessions', icon: '🔐', perm: 'sessions.view' },
  { id: 'teams',     label: 'Teams',        icon: '🧩', perm: 'teams.manage' },
];

export default function Users({ superAdmin = false }) {
  const { can, effectiveInfo } = useAuth();
  // Teams are for business clients (3.19.0): hidden when an individual client is picked
  const picked = (effectiveInfo?.accounts || []).find(a => a.id === effectiveInfo?.accountId);
  // Individual clients (3.19.12): the owner adds their own staff (up to 3);
  // the tab and the People section are called Staff
  const staff = picked?.type === 'individual';
  const sections = SECTIONS.filter(t => (superAdmin || can(t.perm)) && !(t.id === 'teams' && staff))
    .map(t => (t.id === 'people' && staff ? { ...t, label: 'Staff' } : t));
  return (
    <SectionTabs tabId="users" title={staff ? '🎭 Staff' : '🎭 Users'} sections={sections} aliases={{ users: 'people', staff: 'people' }}>
      {sub => (
        <>
          {sub === 'people'    && <UserManagement />}
          {sub === 'activity'  && <ActivityLog />}
          {sub === 'sessions'  && <Sessions />}
          {sub === 'teams'     && <Teams />}
        </>
      )}
    </SectionTabs>
  );
}
